import paymentService from '@apiService/paymentService';
import React, { useEffect, useState } from 'react';
import { withNamespaces } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Spinner from './partials/Spinner';

const DibsyPaymentConfirmation = () => {
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const params = useParams();

  const handleCompleteBooking = async () => {
    setLoading(true);
    const response = await paymentService.dibsyCallback({
      reservation_id: params?.reservation_id,
    });
    const { data } = response;
    if (data.status && data.url) {
      window.open(data.url, '_self');
    }
    setLoading(false);
  };

  useEffect(() => {
    console.log({ params });
    const fetchPaymentStatus = async () => {
      try {
        const response = await paymentService.getDibsyPaymentStatus({
          reservation_id: params?.reservation_id,
        });
        const { data } = response;

        if (
          !data ||
          !data.status ||
          !data.Records ||
          !data.Records['status'] ||
          data.Records['status'] != 'succeeded'
        ) {
          return;
        }

        setPaymentStatus(true);
      } catch (error) {
        console.log(error);
      }
    };

    fetchPaymentStatus();
  }, []);

  return (
    <div className="w-full h-full mt-3">
      <div className="w-full text-center mx-autp">
        {paymentStatus === null && (
          <p className="text-gray-600">Confirming your payment...</p>
        )}

        {paymentStatus === false && (
          <>
            <h2 className="font-weight-bold text-danger">Payment Failed</h2>
            <p className="mt-2">
              We were unable to confirm your payment. Please try again.
            </p>
          </>
        )}

        {paymentStatus === true && (
          <div>
            <h2 className="text-2xl font-semibold text-green-600">
              Payment Successful 🎉
            </h2>
            <p className="mt-2 text-gray-600">
              Your payment has been confirmed. You can now complete your booking.
            </p>
            <button
              onClick={handleCompleteBooking}
              className="btn-main mx-auto my-3"
            >
              {loading && (
                <div className="row">
                  <div className="col-12 text-center">
                    <Spinner />
                  </div>
                </div>
              )}
              Complete booking & collect ticket
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default withNamespaces()(DibsyPaymentConfirmation);
